// NOTE: this file was auto-generated on 2023-03-29T03:48:07.906Z

import React from 'react';
import { IconWithBackground } from 'subframe/index';
import styles from './EmptyMessage.module.scss';
import * as SubframeCore from '@subframe/core';

interface EmptyMessageRootProps
  extends React.ButtonHTMLAttributes<HTMLDivElement> {
  className?: string;
  heading: string;
  message: string | JSX.Element;
  iconName?: SubframeCore.IconName;
  iconVariant?: 'brand' | 'neutral' | 'error' | 'success' | 'warning';
  iconSize?: 'x-large' | 'large' | 'medium' | 'small' | 'x-small';
  dataCy?: string;
}

const EmptyMessageRoot = React.forwardRef<HTMLElement, EmptyMessageRootProps>(
  function EmptyMessageRoot(
    {
      heading,
      message,
      iconName = 'FeatherCheck',
      iconVariant = 'success',
      iconSize = 'medium',
      dataCy = 'empty-message',
      className,

      ...otherProps
    }: EmptyMessageRootProps,
    ref,
  ) {
    return (
      <div className={styles['stack']} data-cy={dataCy}>
        <div className={styles['notDetected']}>
          <IconWithBackground
            variant={iconVariant}
            size={iconSize}
            icon={iconName}
          />
          <span className={styles['subheaderText']}>{heading} </span>
          <span className={styles['text-7aa833db']}>{message}</span>
        </div>
      </div>
    );
  },
);

export const EmptyMessage = EmptyMessageRoot;
